import * as React from 'react'

import { BaseIcon/*, Props*/ } from './BaseIcon'

export class Checkmark extends BaseIcon {
 /*constructor (props: Props) {
    super(props)
  }*/

  public render () {
    const className = this.props.className ? `${this.defaults.className} ${this.getSize()} ${this.props.className}`
      : `${this.defaults.className} ${this.getSize()}`

    //const viewBox = this.props.viewBox ? this.props.viewBox : this.defaults.viewBox

    // tslint:disable    
    return (
      <div>
      <svg className={className} viewBox="0 -960 960 960" ><path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"/></svg> </div>
    )
 }
}
export default Checkmark